// extracted by mini-css-extract-plugin
module.exports = {"sidebarList":"SidebarMenu-module__sidebarList___1XFAa","emoji":"SidebarMenu-module__emoji___3DaXP","selected":"SidebarMenu-module__selected___2As-x"};